import { createFileRoute, Outlet } from '@tanstack/react-router'
import { QuoteContextBar } from '@/features/quote-builder/shell/quote-context-bar'

export const Route = createFileRoute('/_authenticated/quotes/$quoteId')({
  staticData: { title: 'Quote' },
  component: QuoteLayout,
})

function QuoteLayout() {
  const { quoteId } = Route.useParams()
  return (
    <>
      <QuoteContextBar quoteId={quoteId} />
      <Outlet />
    </>
  )
}
